import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Language } from '../../shared/types/language';
import { Observable } from 'rxjs';
import { OeAppService } from '../../shared/oe-app.service';
import { NextPlatformTourDto } from './next-platform-tour-dto';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { PlatformTourModalComponent } from '../platform-tour-modal/platform-tour-modal.component';

@Injectable()
export class PlatformTourService {
  private static readonly MODAL_CLASS = 'platform-tour-modal-window';
  private oeLiveclassServiceHost: string;

  constructor(private httpClient: HttpClient, oeAppService: OeAppService, private ngbModal: NgbModal) {
    const oeLiveClassServiceHost = oeAppService.getData('oeLiveClassServiceHost');
    if (!oeLiveClassServiceHost) {
      throw Error('Failure finding oeLiveClassService Host definition!');
    }

    this.oeLiveclassServiceHost = oeLiveClassServiceHost;
  }

  showModal() {
    this.ngbModal.open(PlatformTourModalComponent, {
      windowClass: PlatformTourService.MODAL_CLASS,
      centered: true,
    })
  }

  getNextPlatformTour(language: Language): Observable<NextPlatformTourDto> {
    const supportedLanguages = [Language.SPANISH, Language.PORTUGUESE, Language.TURKISH];

    language = !supportedLanguages.includes(language) ? Language.SPANISH : language;

    return this.httpClient.get<NextPlatformTourDto>(
      `${this.oeLiveclassServiceHost}/platform-tours/next?language=${language}`
    );
  }
}



// WEBPACK FOOTER //
// ./ts/app/platform-tour/platform-tour-service/platform-tour.service.ts